import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'

import { usePARoutesConditions } from '@pages/PaymentAgent/PaymentAgentRoutes'

import { SearchIcon } from '@ui/icons/Search.icon'
import { UserIcon } from '@ui/icons/User.icon'
import { WalletIcon } from '@ui/icons/Wallet.icon'
import { WavyBillIcon } from '@ui/icons/WavyBill.icon'

import { CommonPaths } from '@utils/path'

import { TickmillProductType } from '@model/TickmillProductType'

import { MenuSection, useWithMobileIcon } from '../useMenuSections'

export const usePAMenu = (): MenuSection => {
  const { t } = useTranslation()
  const { isPAVisible } = usePARoutesConditions()

  const withMobileIcon = useWithMobileIcon()

  return useMemo(
    () => ({
      id: 'payment-agent',
      label: t('Tabs.Payment Agent'),
      icon: WavyBillIcon,
      condition: isPAVisible,
      products: [TickmillProductType.CFD],
      children: [
        {
          id: 'pa-wallets',
          label: t('Tabs.Wallets'),
          path: CommonPaths.PaymentAgentWallets,
          icon: withMobileIcon(WalletIcon),
        },
        {
          id: 'pa-transaction-history',
          label: t('Tabs.Transaction History'),
          path: '/dashboard/payment-agent/transaction-history',
          icon: withMobileIcon(SearchIcon),
        },
        {
          id: 'pa-profile-info',
          label: t('Tabs.Profile Info'),
          path: '/dashboard/payment-agent/profile-info',
          icon: withMobileIcon(UserIcon),
        },
      ],
    }),
    [t, isPAVisible, withMobileIcon]
  )
}
